import { useMemo } from 'react';
import HamHeader from '../Header/HamburgerHeader';
import constant from '@components/common/globalization';
import { useOutletContext } from 'react-router-dom';
import Table from './Table';
import { getTimeInHrsMins } from '../../../../utility/fireboardUtil';
import { getObjectValue } from '@utility/utills';
import { safeJsonParse } from '../../../../utility/helperFunction';
import { APP_CONFIG } from '@constants';
import Popup from '@components/common/Popup/Popup';
import { PopupContent } from '@components/common/Popup/index';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const NotificationScreen = (props) => {
  const {
    popup,
    notificationTableData,
    venueNotificationTableData,
    acknowledgeNotification,
    notificationGoAndDismiss,
    venueStores,
  } = useOutletContext();

  const deviceGroup = getObjectValue(() =>
    JSON.parse(window.sessionStorage.getItem('deviceInfo') || '{}')
  )?.deviceGroup;
  const isVenueMode = deviceGroup?.startMode === 6 || false;
  const getNotificationsForVenue = [
    ...venueNotificationTableData,
    ...notificationTableData,
  ];

  const filteredNotifications = useMemo(() => {
    if (isVenueMode) {
      return getNotificationsForVenue?.filter(item =>
        deviceGroup?.fireBoardNotificationFilters?.includes(
          item?.notificationTypeId
        )
      );
    } else {
      return notificationTableData?.filter(item =>
        deviceGroup?.fireBoardNotificationFilters?.includes(
          item?.notificationTypeId
        )
      );
    }
  }, [notificationTableData, deviceGroup]);

  const sortedNotifications = useMemo(() => {
    return [...filteredNotifications].sort((a, b) => b.id - a.id);
  }, [filteredNotifications]);

  const getVenueStoresName = storeId => {
    const venuesInfoList = venueStores?.saStoreInfos;
    const storeFromVenue = venuesInfoList?.find(store => store.id === storeId);
    return storeFromVenue?.name;
  };

  const tableRows = useMemo(() => {
    return sortedNotifications.map(notification => ({
      sourceType: notification.data?.sourceType ?? null,
      isNew: notification.isNew ?? false,
      time: getTimeInHrsMins(notification?.openDate),
      message: notification.note,
      ack: true,
      dismiss: true,
      goAndDismiss: true,
      store: getVenueStoresName(notification?.storeId),
      notification,
    }));
  }, [sortedNotifications]);

  return (
    <div className="w-100 h-100 position-relative">
      <HamHeader
        label={FLABEL().HEADER_NOTIFICATIONS}
        onClickback={() => props.navigate(`${APP_CONFIG.BASE_URL}/fireboard`)}
      />

      <div className="h-100">
        <Table
          notificationTableData={tableRows}
          acknowledgeNotification={acknowledgeNotification}
          notificationGoAndDismiss={notificationGoAndDismiss}
          isVenue={isVenueMode}
        />
      </div>
      <Popup visible={!!popup} fullPopupView={false}>
        <PopupContent {...popup} />
      </Popup>
    </div>
  );
};

export default NotificationScreen;
